"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var minW = 256;
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\t", ";\n"], ["\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\t", ";\n"])), function (props) { return props.theme.gallery.container; });
var Viewport = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 100%;\n\toverflow-x: ", ";\n\toverflow-y: ", ";\n\t\n\t", ";\n"], ["\n\twidth: 100%;\n\theight: 100%;\n\toverflow-x: ", ";\n\toverflow-y: ", ";\n\t\n\t", ";\n"])), function (props) { return props.horizontal ? 'auto' : 'hidden'; }, function (props) { return props.horizontal ? 'hidden' : 'auto'; }, function (props) { return props.theme.gallery.viewport; });
var Gradient = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tpointer-events: none;\n\tposition: absolute;\n\t", "\n\t", "\n\topacity: ", ";\n\t@media (prefers-reduced-motion: no-preference) {\n\t\ttransition: opacity 0.5s linear;\n\t}\n\n\t", ";\n"], ["\n\tpointer-events: none;\n\tposition: absolute;\n\t", "\n\t", "\n\topacity: ", ";\n\t@media (prefers-reduced-motion: no-preference) {\n\t\ttransition: opacity 0.5s linear;\n\t}\n\n\t", ";\n"])), function (props) { return !props.horizontal && "bottom: 0; width: 100%; height: 30%"; }, function (props) { return props.horizontal && "right: 0; height: 100%; width: 30%"; }, function (props) { return props.show ? 1 : 0; }, function (props) { return props.theme.gallery.gradient; });
var Content = styled_components_1.default.div.attrs(function (props) { return ({ style: { width: props.width, height: props.height, scrollSnapPointsX: props.item.width, scrollSnapPointsY: props.item.height } }); })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tposition: relative;\n\n\t", ";\n"], ["\n\tposition: relative;\n\n\t", ";\n"])), function (props) { return props.theme.gallery.content; });
var EmptyContent = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\t", "\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\t", "\n"])), function (props) { return props.theme.gallery.emptyContent; });
var EmptyHead = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.gallery.emptyHeader; });
var EmptySub = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.gallery.emptySub; });
var Item = styled_components_1.default.div.attrs(function (props) { return ({ style: { left: props.x, top: props.y, width: props.width, height: props.height } }); })(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tposition: absolute;\n\n\t", ";\n"], ["\n\tposition: absolute;\n\n\t", ";\n"])), function (props) { return props.theme.gallery.item; });
var Gallery = /** @class */ (function (_super) {
    __extends(Gallery, _super);
    function Gallery(props) {
        var _this = _super.call(this, props) || this;
        _this.onViewportResized = function () {
            if (!_this.viewportRef.current) {
                return;
            }
            var aw = (_this.props.desiredAspect ? _this.props.desiredAspect : 16);
            var ah = (_this.props.desiredAspect ? 1 : 9);
            var minWidth = minW;
            var aspect = aw / ah;
            var pg = _this.props.pixelGap !== undefined ? _this.props.pixelGap : 25;
            var columns = _this.state.currentColumns;
            var rows = _this.state.currentRows;
            var viewportWidth = _this.viewportRef.current.offsetWidth;
            var viewportHeight = _this.viewportRef.current.offsetHeight;
            var gutter = _this.state.scrollable && window.matchMedia && !window.matchMedia(_this.props.theme.breakpoints.S).matches;
            if (!gutter) {
                if (_this.props.horizontal) {
                    viewportHeight += pg;
                }
                else {
                    viewportWidth += pg;
                }
            }
            var itemWidth = viewportWidth / columns - pg;
            var itemHeight = viewportWidth / columns - pg;
            if (_this.props.horizontal) {
                rows = Math.floor(viewportHeight / (_this.props.minHeightPerRow ? _this.props.minHeightPerRow : (minWidth / aw) * ah));
                if (rows > _this.props.maxVisibleRows) {
                    rows = _this.props.maxVisibleRows;
                }
                else if (rows < 1) {
                    rows = 1;
                }
                var heightWillBe = viewportHeight / rows;
                var widthWouldBe = heightWillBe * (aspect);
                columns = viewportWidth / widthWouldBe;
                itemHeight = heightWillBe - pg;
                itemWidth = viewportWidth / columns - pg;
            }
            else {
                columns = Math.floor(viewportWidth / (_this.props.minWidthPerCol ? _this.props.minWidthPerCol : minWidth));
                if (columns > _this.props.maxVisibleColumns) {
                    columns = _this.props.maxVisibleColumns;
                }
                else if (columns < 1) {
                    columns = 1;
                }
                var widthWillBe = viewportWidth / columns;
                var heightWouldBe = widthWillBe * (1 / aspect);
                rows = viewportHeight / heightWouldBe;
                itemWidth = widthWillBe - pg;
                itemHeight = viewportHeight / rows - pg;
            }
            //Adjust scroll to preserve focus
            _this.viewportRef.current.scrollLeft = (_this.viewportRef.current.scrollLeft / _this.state.item.width) * itemWidth;
            _this.viewportRef.current.scrollTop = (_this.viewportRef.current.scrollTop / _this.state.item.height) * itemHeight;
            _this.setState({ item: { width: itemWidth, height: itemHeight }, currentColumns: columns, currentRows: rows }, function () { _this.updateVisibleContent(); });
        };
        _this.updateVisibleContent = function (force) {
            if (!_this.viewportRef.current) {
                return;
            }
            var cols = _this.state.currentColumns;
            var rows = _this.state.currentRows;
            var itemWidth = _this.state.item.width;
            var itemHeight = _this.state.item.height;
            var start;
            var max;
            if (_this.props.horizontal) {
                start = Math.max(0, (Math.floor(_this.viewportRef.current.scrollLeft / itemWidth) - _this.props.cache) * rows);
                max = rows * (cols + (2 * _this.props.cache));
            }
            else {
                start = Math.max(0, (Math.floor(_this.viewportRef.current.scrollTop / itemHeight) - _this.props.cache) * cols);
                max = cols * (rows + (2 * _this.props.cache));
            }
            var scrollable = _this.props.count > (cols * rows);
            var showGradient = scrollable && _this.viewportRef.current.scrollTop === 0;
            _this.setState({ scrollable: scrollable, showGradient: showGradient });
            if (start !== _this.state.pending || force) {
                _this.setState({ pending: start });
                var timestamp_1 = Date.now();
                _this.props.getItems(start, max).then(function (items) {
                    _this.setState(function (prevState) {
                        if (prevState.timestamp > timestamp_1) {
                            return __assign({}, prevState);
                        }
                        for (var _i = 0, _a = prevState.items; _i < _a.length; _i++) {
                            var item = _a[_i];
                            if (item.release !== undefined) {
                                item.release();
                            }
                        }
                        return { start: start, item: { width: itemWidth, height: itemHeight }, items: items, timestamp: timestamp_1 };
                    });
                });
            }
        };
        _this.viewportRef = react_1.default.createRef();
        _this.state = {
            pending: -1,
            start: -1,
            item: {
                width: 0,
                height: 0
            },
            timestamp: 0,
            items: [],
            currentRows: props.maxVisibleRows,
            currentColumns: props.maxVisibleColumns,
            scrollable: true,
            showGradient: true
        };
        return _this;
    }
    Gallery.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.onViewportResized);
        this.onViewportResized();
    };
    Gallery.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.onViewportResized);
    };
    Gallery.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.count !== this.props.count) {
            this.updateVisibleContent(true);
        }
    };
    Gallery.prototype.render = function () {
        var _this = this;
        var contentWidth = "100%";
        var contentHeight = "100%";
        var pg = this.props.pixelGap !== undefined ? this.props.pixelGap : 25;
        var cols = this.state.currentColumns;
        var rows = this.state.currentRows;
        if (this.state.items.length >= 1) {
            if (this.props.horizontal) {
                contentWidth = this.state.item.width * Math.ceil(this.props.count / rows);
            }
            else {
                contentHeight = this.state.item.height * Math.ceil(this.props.count / cols);
            }
        }
        return (react_1.default.createElement(Container, { className: this.props.className }, this.props.count > 0 ?
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Viewport, { ref: this.viewportRef, horizontal: this.props.horizontal, onScroll: function () { return _this.updateVisibleContent(); }, id: this.props.Id }, this.state.start >= 0 && this.state.items.length >= 1 &&
                    react_1.default.createElement(Content, { id: "Content", width: contentWidth, height: contentHeight, item: this.state.item }, this.state.items.map(function (item, i) {
                        var w = _this.state.item.width;
                        var h = _this.state.item.height;
                        var index = _this.state.start + i;
                        var x, y;
                        if (_this.props.horizontal) {
                            x = (w + pg) * Math.floor(index / rows);
                            y = (h + pg) * (index % rows);
                        }
                        else {
                            x = (w + pg) * (index % cols);
                            y = (h + pg) * Math.floor(index / cols);
                        }
                        var prev = i > 0 ? _this.state.items[i - 1] : _this.state.items[_this.state.items.length - 1];
                        var next = i + 1 < _this.state.items.length ? _this.state.items[i + 1] : _this.state.items[0];
                        return (react_1.default.createElement(Item, { "data-automationid": 'gallery_item_wrapper', key: index, x: x, y: y, width: w, height: h }, react_1.default.createElement(_this.props.item.type, __assign(__assign({ key: index }, _this.props.item.props), { item: item, prev: prev, next: next }))));
                    }))),
                react_1.default.createElement(Gradient, { horizontal: this.props.horizontal, show: this.state.showGradient }))
            :
                react_1.default.createElement(EmptyContent, { id: "EmptyContent" },
                    this.props.emptyIcon,
                    react_1.default.createElement(EmptyHead, null, this.props.emptyTextHeading),
                    react_1.default.createElement(EmptySub, null, this.props.emptyTextContent))));
    };
    Gallery.defaultProps = {
        cache: 3,
        getItems: function () {
            return new Promise(function () {
            });
        },
    };
    return Gallery;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Gallery);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=Gallery.js.map